import { Assistants } from '@local/client-contracts';

export interface AnswersResultExtra {
  searchId?: string;
  status?: Assistants.AnswerStatusType;
  searchParameters?: Assistants.SelfQueryParameters;
}
